function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIsupportyou({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#A94EF1",
    fillRule: "evenodd",
    d: "m9.177 5.978-.44.237a5.817 5.817 0 0 0-2.358 2.327 3.024 3.024 0 0 0-.164.477c-.074.259-.157.589-.244.968-.176.756-.366 1.69-.543 2.6a184.296 184.296 0 0 0-.547 2.95h1.787v.844c0 .138.011.273.034.405H7c.67 0 1.251-.32 1.596-.794l.293-.405.81.587-.294.405a2.958 2.958 0 0 1-2.289 1.204 2.413 2.413 0 0 0 1.968 1.015h2.794V21.5h3.706L17.6 10.601l.984.182L16.416 22.5h-5.538v-2.702H9.084a3.416 3.416 0 0 1-3.413-3.261H3.692l.101-.585.493.085-.493-.085.014-.079.038-.22a194.925 194.925 0 0 1 .601-3.256c.178-.915.371-1.862.55-2.636.09-.386.177-.735.257-1.017.077-.266.16-.519.248-.681a6.817 6.817 0 0 1 2.763-2.73l.44-.236.473.881ZM8.513 12a1.488 1.488 0 0 1 1.413 1.511v.5h-1v-.5a.482.482 0 0 0-.162-.388.498.498 0 0 0-.277-.123c-.177-.005-.299.006-.382.052-.037.021-.153.092-.18.447l-.039.499-.997-.077.039-.498c.046-.606.293-1.02.687-1.242.348-.196.726-.185.898-.18Z",
    clipRule: "evenodd",
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94EF1",
    d: "M11.344 7.463a2.793 2.793 0 0 1 2.946-2.238 2.786 2.786 0 0 1 1.597 4.896c-.455.374-.74.916-.791 1.503l-.1 1.319-2.563-.193.098-1.32a2.145 2.145 0 0 0-.535-1.577 2.777 2.777 0 0 1-.652-2.39Z",
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94EF1",
    fillRule: "evenodd",
    d: "m10.584 4.777-1-1.5.832-.554 1 1.5-.832.554ZM13.957 3.626l.087-1.8 1 .048-.088 1.8-.998-.048ZM18.021 5.728l1.455-1.064.59.807-1.454 1.064-.59-.807Z",
    clipRule: "evenodd",
    style: {
      fill: "#000"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIsupportyou);
export default __webpack_public_path__ + "static/media/icon_i support you.6db64a1cb284f7e20502dc38a9014584.svg";
export { ForwardRef as ReactComponent };